import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { GuidaLabel } from '@inter-ikea-guida/framework';
import { SkapaToggle } from '@inter-ikea-guida/skapa';
import { useKompis } from '../../contexts';
import { getTranslation } from '../../store/i18n/selectors';
import { OPTION_TYPE_MEASUREMENT, TOGGLE } from '../../utils';
import { getFormattedMeasurement } from '../common/FormattedMeasurement';
import { StyledToggleGroup } from './styles';
export const FilterToggle = ({ label, dataTestId, options, useMetricMeasures, formState, formObjectId, onClick }) => {
    const translate = useSelector(getTranslation);
    const { translations } = useKompis();
    const buttons = options.map(option => ({
        text: option.type === OPTION_TYPE_MEASUREMENT
            ? getFormattedMeasurement(parseInt(option.value, 10), translate, !useMetricMeasures, false, translations.kompis)
            : translate(option.label)
    }));
    if (!buttons.length) {
        return _jsx(_Fragment, {});
    }
    // If more than three options, only use the first three
    if (options.length > 3) {
        options.splice(0, 3);
    }
    return (_jsxs(_Fragment, { children: [_jsx(GuidaLabel, { htmlFor: formObjectId, text: label }), _jsx(StyledToggleGroup, { children: _jsx(SkapaToggle, { dataTestId: dataTestId, buttons: buttons, activeIndex: formState.selectState[formObjectId]?.selectedIndex || 0, onClick: (_e, index) => onClick(formObjectId, options[index].value, TOGGLE, index), fluid: true, ariaLabel: translate(label) }) })] }));
};
//# sourceMappingURL=FilterToggle.js.map